// Modern Scroll Animations and Smooth Interactions
document.addEventListener('DOMContentLoaded', function() {
    
    // Elements
    const navbar = document.querySelector('.navbar');
    const storyItems = document.querySelectorAll('.story-item');
    const activityCards = document.querySelectorAll('.activity-card');
    const sections = document.querySelectorAll('section');
    
    // Throttle function for performance
    function throttle(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    
    // Navbar scroll effect
    function handleNavbarScroll() {
        const scrolled = window.pageYOffset;
        
        if (scrolled > 100) {
            navbar.style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.1)';
        } else {
            navbar.style.backgroundColor = 'transparent';
            navbar.style.backdropFilter = 'blur(10px)';
            navbar.style.boxShadow = 'none';
        }
    }
    
    // Intersection Observer for fade-in animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);
    
    // Apply fade-in animation to elements
    function initFadeAnimations() {
        const animateElements = document.querySelectorAll('.activity-card, .story-text, .thoughts-text, .message-text');
        
        animateElements.forEach((element, index) => {
            element.style.opacity = '0';
            element.style.transform = 'translateY(30px)';
            element.style.transition = `opacity 0.8s ease ${index * 0.1}s, transform 0.8s ease ${index * 0.1}s`;
            observer.observe(element);
        });
    }
    
    // Smooth scrolling for navigation links
    function initSmoothScroll() {
        const navLinks = document.querySelectorAll('.nav-link');
        
        navLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                
                const targetId = this.getAttribute('href');
                const targetSection = document.querySelector(targetId);
                
                if (targetSection) {
                    const offsetTop = targetSection.offsetTop - 80;
                    
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }
    
    // Mobile menu toggle
    function initMobileMenu() {
        const mobileToggle = document.querySelector('.mobile-menu-toggle');
        const navMenu = document.querySelector('.nav-menu');
        
        if (mobileToggle && navMenu) {
            mobileToggle.addEventListener('click', function() {
                this.classList.toggle('active');
                navMenu.classList.toggle('active');
            });
        }
    }
    
    // Wave animation effect
    function initWaveAnimation() {
        const waveDividers = document.querySelectorAll('.wave-divider');
        
        waveDividers.forEach((wave, index) => {
            wave.style.opacity = '0';
            wave.style.transform = 'scaleX(0)';
            wave.style.transition = `opacity 1s ease ${index * 0.2}s, transform 1s ease ${index * 0.2}s`;
            
            observer.observe(wave);
        });
    }
    
    // Hover effects for cards
    function initCardHoverEffects() {
        activityCards.forEach(card => {
            card.addEventListener('mouseenter', function() {
                this.style.transform = 'translateY(-10px) scale(1.02)';
            });
            
            card.addEventListener('mouseleave', function() {
                this.style.transform = 'translateY(0) scale(1)';
            });
        });
    }
    
    // Scroll progress indicator
    function initScrollProgress() {
        const progressBar = document.createElement('div');
        progressBar.style.position = 'fixed';
        progressBar.style.top = '0';
        progressBar.style.left = '0';
        progressBar.style.width = '0%';
        progressBar.style.height = '3px';
        progressBar.style.background = 'linear-gradient(90deg, var(--accent-red), var(--accent-orange))';
        progressBar.style.zIndex = '9999';
        progressBar.style.transition = 'width 0.3s ease';
        
        document.body.appendChild(progressBar);
        
        function updateProgress() {
            const windowHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrolled = (window.pageYOffset / windowHeight) * 100;
            progressBar.style.width = `${Math.min(scrolled, 100)}%`;
        }
        
        window.addEventListener('scroll', throttle(updateProgress, 10));
    }
    
    // CTA Button interactions
    function initCTAButtons() {
        // Individual service CTAs
        const serviceButtons = document.querySelectorAll('.cta-button[data-service]');
        serviceButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                const service = this.dataset.service;
                handleServiceCTA(service);
            });
        });
        
        // Main CTAs
        const mainButtons = document.querySelectorAll('.main-cta-button[data-action]');
        mainButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                const action = this.dataset.action;
                handleMainCTA(action);
            });
        });
    }
    

    // Handle main CTAs
    function handleMainCTA(action) {
        if (action === 'contact') {
            showContactModal();
        } else if (action === 'newsletter') {
            showNewsletterModal();
        }
    }
    
    // Contact modal
    function showContactModal() {
        const modalHTML = `
            <div class="modal-overlay" id="contactModal">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>お問い合わせ</h3>
                        <button class="close-modal" onclick="closeModal('contactModal')">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form class="contact-form">
                            <div class="form-group">
                                <label>お名前 <span class="required">*</span></label>
                                <input type="text" name="name" required>
                            </div>
                            <div class="form-group">
                                <label>メールアドレス <span class="required">*</span></label>
                                <input type="email" name="email" required>
                            </div>
                            <div class="form-group">
                                <label>お問い合わせ内容 <span class="required">*</span></label>
                                <textarea name="message" rows="4" required></textarea>
                            </div>
                            <button type="submit" class="submit-button">送信する</button>
                        </form>
                    </div>
                </div>
            </div>
        `;
        
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        document.getElementById('contactModal').style.display = 'flex';
    }
    
    // Newsletter modal
    function showNewsletterModal() {
        const modalHTML = `
            <div class="modal-overlay" id="newsletterModal">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>最新情報を受け取る</h3>
                        <button class="close-modal" onclick="closeModal('newsletterModal')">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p>パワーポイントの最新ノウハウや新しいテンプレート情報をお届けします。</p>
                        <form class="newsletter-form">
                            <div class="form-group">
                                <label>メールアドレス <span class="required">*</span></label>
                                <input type="email" name="email" required>
                            </div>
                            <div class="form-group">
                                <label>
                                    <input type="checkbox" name="consent" required>
                                    プライバシーポリシーに同意する
                                </label>
                            </div>
                            <button type="submit" class="submit-button">登録する</button>
                        </form>
                    </div>
                </div>
            </div>
        `;
        
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        document.getElementById('newsletterModal').style.display = 'flex';
    }

    // Initialize all functions
    initFadeAnimations();
    initSmoothScroll();
    initMobileMenu();
    initWaveAnimation();
    initCardHoverEffects();
    initScrollProgress();
    initCTAButtons();
    
    // Throttled scroll event listener
    window.addEventListener('scroll', throttle(handleNavbarScroll, 10));
    
    // Initial navbar state
    handleNavbarScroll();
});

// CSS custom properties for dynamic theming
document.documentElement.style.setProperty('--scroll-progress', '0%');

// Add some CSS for the wave dividers animation
const style = document.createElement('style');
style.textContent = `
    .wave-divider {
        transform-origin: left center;
    }
    
    .activity-card {
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    
    .activity-card:hover {
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
    }
    
    .hero-catchphrase {
        animation: fadeInUp 1s ease 0.5s both;
    }
    
    .profile-image {
        animation: bounceIn 1s ease 1s both;
    }
    
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(30px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    @keyframes bounceIn {
        0% {
            opacity: 0;
            transform: scale(0.3);
        }
        50% {
            opacity: 1;
            transform: scale(1.05);
        }
        70% {
            transform: scale(0.9);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }
    
    /* Modal Styles */
    .modal-overlay {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        z-index: 10000;
        justify-content: center;
        align-items: center;
    }
    
    .modal-content {
        background: white;
        border-radius: 12px;
        max-width: 500px;
        width: 90%;
        max-height: 80vh;
        overflow-y: auto;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    }
    
    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1.5rem;
        border-bottom: 1px solid #eee;
    }
    
    .modal-header h3 {
        margin: 0;
        color: var(--secondary-blue);
    }
    
    .close-modal {
        background: none;
        border: none;
        font-size: 1.5rem;
        cursor: pointer;
        color: #999;
    }
    
    .modal-body {
        padding: 1.5rem;
    }
    
    .form-group {
        margin-bottom: 1rem;
    }
    
    .form-group label {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: 500;
        color: var(--text-dark);
    }
    
    .required {
        color: var(--accent-red);
    }
    
    .form-group input,
    .form-group textarea {
        width: 100%;
        padding: 0.75rem;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 1rem;
    }
    
    .form-group input:focus,
    .form-group textarea:focus {
        outline: none;
        border-color: var(--accent-red);
    }
    
    .submit-button {
        width: 100%;
        padding: 1rem;
        background: linear-gradient(135deg, var(--accent-red), var(--accent-orange));
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: var(--transition);
    }
    
    .submit-button:hover {
        transform: translateY(-2px);
        box-shadow: var(--shadow-hover);
    }
`;
document.head.appendChild(style);

// Global modal close function
window.closeModal = function(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.style.display = 'none';
        setTimeout(() => modal.remove(), 300);
    }
};